import React from 'react';

/** Retention widget on the SaaS phone mockup */
export default function SaasRetentionFloat({ className = '', compact = false, inset = false }) {
  const r = inset ? 14 : 17;
  const c = 2 * Math.PI * r;
  const pct = 0.84;

  const shellClass = inset
    ? compact
      ? 'w-[86px] rounded-xl border border-gray-100 bg-white/95 backdrop-blur-sm px-1.5 py-1.5 shadow-md'
      : 'w-[96px] rounded-xl border border-gray-100 bg-white/95 backdrop-blur-sm px-2 py-2 shadow-md'
    : compact
      ? 'w-[100px] rounded-2xl border border-gray-100 bg-white px-2 py-2 shadow-[0_16px_36px_-8px_rgba(0,0,0,0.2)]'
      : 'w-[118px] md:w-[128px] rounded-2xl border border-gray-100 bg-white px-3 py-3 shadow-[0_22px_48px_-8px_rgba(0,0,0,0.2)]';

  const ringClass = inset
    ? compact
      ? 'h-[38px] w-[38px]'
      : 'h-[42px] w-[42px]'
    : compact
      ? 'h-[46px] w-[46px]'
      : 'h-[52px] w-[52px] md:h-[56px] md:w-[56px]';

  const pctLabel = inset ? 'text-[9px]' : compact ? 'text-[10px]' : 'text-[11px] md:text-xs';
  const caption = inset ? 'text-[8px]' : compact ? 'text-[9px]' : 'text-[9px] sm:text-[10px]';
  const delta = inset ? 'text-[11px]' : compact ? 'text-[13px]' : 'text-[13px] md:text-[14px]';
  const momLabel = inset || compact ? '↑ 6%' : '↑ 6% MoM';

  return (
    <div className={`${shellClass} ${className}`}>
      <div className={`relative mx-auto ${ringClass}`}>
        <svg viewBox="0 0 44 44" className={inset ? ringClass : compact ? ringClass : 'h-full w-full'}>
          <circle cx="22" cy="22" r={r} fill="none" stroke="#e7e5e4" strokeWidth="3.5" />
          <circle
            cx="22"
            cy="22"
            r={r}
            fill="none"
            stroke="#5ec269"
            strokeWidth="3.5"
            strokeLinecap="round"
            strokeDasharray={c}
            strokeDashoffset={c * (1 - pct)}
            transform="rotate(-90 22 22)"
          />
        </svg>
        <span className={`absolute inset-0 flex items-center justify-center font-bold text-gray-800 ${pctLabel}`}>
          84%
        </span>
      </div>
      <p className={`${caption} font-medium text-gray-500 text-center leading-tight mt-1`}>Net retention</p>
      <p className={`${delta} font-bold text-gray-900 text-center tabular-nums leading-none mt-0.5`}>{momLabel}</p>
    </div>
  );
}
